import { Grid, TextField, Typography } from "@mui/material";

import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { useTemplateLibraryStore } from "../../../../../../store/templateLibraryStore";
import { useShallow } from "zustand/react/shallow";
import { maxFooterChars } from "../../../../channels/global/whatsapp/templates/utils";
import { useCarouselFunctions } from "../../../utils/useCarouselFunctions";
import { isTemplateCreated } from "../../../constant";

const CarouselFormCardFooter = (props: any) => {

    const { cardData, cardIndex, handleChangeText } = props;

    const { createTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
    })));

    const { handleCarouselCardFooterChange } = useCarouselFunctions();

    return (
        <Grid container className={globalStyles.marginTop10px}>

            <Grid item xs={12}>
                <Typography component={'span'} className={styles.templateHeadtext}>
                    Template Footer
                </Typography>
            </Grid>

            <Grid item xs={12} className={globalStyles.marginTop5px}>
                <TextField
                    disabled={isTemplateCreated(createTemplatePayload)}
                    variant="outlined"
                    className={styles.templateGlobalTextfield}
                    value={cardData?.whatsapp_template_footer?.whatsapp_template_footer_value}
                    onChange={(event: any) => {handleCarouselCardFooterChange(event, cardIndex, cardData, handleChangeText)}}
                    sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                        },
                    }}
                    inputProps={{ dir: 'auto' }}
                    fullWidth
                    autoComplete='off'
                    placeholder='Enter template footer'
                    InputProps={{
                        endAdornment: (
                            <span className={styles.footerEndAdornmentStyle}>
                                {`${cardData?.whatsapp_template_footer?.whatsapp_template_footer_value?.length ?? 0}/${maxFooterChars}`}
                            </span>
                        ),
                    }}
                />
            </Grid>
        
        </Grid>
    )
}

export default CarouselFormCardFooter;